﻿import { FunctionComponent, useRef } from "react";
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button } from "@chakra-ui/react";
import { ConfirmationDialogProps } from "./ConfirmationDialogProps";

export const ConfirmationDialog: FunctionComponent<ConfirmationDialogProps> = props => {
    const { isOpen, onClose, onConfirm, isDisabled = false, isLoading = false, confirmColorScheme = "blue", children, title, confirmLabel } = props;
    const cancelRef = useRef(null);

    return (
        <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        {title}
                    </AlertDialogHeader>

                    <AlertDialogBody>{children}</AlertDialogBody>

                    <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={onClose} isDisabled={isDisabled || isLoading}>
                            Cancel
                        </Button>
                        <Button colorScheme={confirmColorScheme} onClick={onConfirm} ml={3} isDisabled={isDisabled} isLoading={isLoading}>
                            {confirmLabel}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
};
